"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _gerenciatdUnifiedicons = require("@bit/gerenciatd.unifiedicons.svg-icon");

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var pathMedium = /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.Fragment, {
  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M20.837,8.979a3.238,3.238,0,0,0-2.7-3.063l-.21-.038-.029-.21C17.66,4.084,16.562.4,11.466.4A6.623,6.623,0,0,0,6.5,2.29a6.482,6.482,0,0,0-1.68,3.455l-.029.21-.21.038A2.861,2.861,0,0,0,2.2,9.046c0,2.586,1.8,8.665,2.157,9.858l.01.038a.337.337,0,0,0,.076.124l.248.248a.291.291,0,0,0,.2.086h12.94a.264.264,0,0,0,.124-.029l.41-.21a.364.364,0,0,0,.143-.153l.01-.019C18.843,18.226,21.171,11.727,20.837,8.979Zm-2.767,9.6-.048.115-.258.115H16.037V15.974a.273.273,0,0,0-.286-.277.277.277,0,0,0-.277.277v2.834H7.258V15.974a.273.273,0,0,0-.286-.277.277.277,0,0,0-.277.277v2.834H4.939l-.067-.21c-.086-.277-2.08-6.919-2.08-9.552A2.326,2.326,0,0,1,5.034,6.507h.057l.038.01h.01a1.609,1.609,0,0,1,1.012.429A2.256,2.256,0,0,1,6.7,8.616v.029l.01.124A.283.283,0,0,0,7,9.036h.029a.281.281,0,0,0,.258-.305L7.277,8.6a2.764,2.764,0,0,0-.725-2.061,2.088,2.088,0,0,0-.907-.515l-.258-.076.048-.267A6.088,6.088,0,0,1,6.809,2.824,5.981,5.981,0,0,1,11.485.973,5.754,5.754,0,0,1,16.075,2.8a5.673,5.673,0,0,1,1.26,2.815l.038.258-.258.067a2.636,2.636,0,0,0-1.746,2.672v.029l-.01.076a.325.325,0,0,0,.067.21.284.284,0,0,0,.191.1h.029a.283.283,0,0,0,.286-.267l.01-.124a2.242,2.242,0,0,1,.7-1.813,1.8,1.8,0,0,1,.83-.372l.019-.019h.124c.038,0,.067.01.086.01a2.631,2.631,0,0,1,2.577,2.605C20.58,11.575,18.49,17.425,18.07,18.579Z",
    fill: "#fff"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M53.238,102H45.164A1.169,1.169,0,0,0,44,103.164v1.67A1.169,1.169,0,0,0,45.164,106h8.073a1.169,1.169,0,0,0,1.164-1.164v-1.67A1.175,1.175,0,0,0,53.238,102Zm.582,2.834a.587.587,0,0,1-.582.592H45.164a.593.593,0,0,1-.582-.592v-1.67a.584.584,0,0,1,.582-.582h8.073a.584.584,0,0,1,.582.582v1.67Z",
    transform: "translate(-37.811 -91.904)",
    fill: "#fff"
  })]
});

var SeriesIcon = function SeriesIcon(props) {
  var kind = props.kind;
  var path = null;

  switch (kind) {
    default:
      path = pathMedium;
  }

  var viewBox = props.viewBox,
      mainDimension = props.mainDimension;

  if (!viewBox) {
    viewBox = '1.9 0.2 19.3 19.3';
  }

  if (!mainDimension) {
    mainDimension = 'both';
  }

  var Icon = (0, _gerenciatdUnifiedicons.CreateSvgIcon)(path, "SeriesIcon-".concat(kind));
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(Icon, _objectSpread(_objectSpread({}, props), {}, {
    viewBox: viewBox,
    mainDimension: mainDimension
  }));
};

var _default = SeriesIcon;
exports["default"] = _default;

//# sourceMappingURL=index.js.map